import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ToasterServiceService } from '../../service/toaster.service';
import { MainService } from '../../service/main.service';
import { environment } from '../../../environments/environment';
import { Location } from '@angular/common';
import { ApiUrls } from '../../apiRouts';

@Component({
  selector: 'app-village-member-list',
  templateUrl: './village-member-list.component.html',
  styleUrl: './village-member-list.component.scss'
})
export class VillageMemberListComponent implements OnInit{
  baseUrl = environment.imageURL;
  VillageList: any;
  village_id: any;
  VillageMemberListData: any[] = [];

  constructor(    
    private router: Router,
    private _route: ActivatedRoute,
    private toasterService: ToasterServiceService,
    private location: Location,
    private mainService: MainService) {
    this._route.params.subscribe((params: any) => {
      this.village_id = params['villageId'];
    })
  }

  ngOnInit(): void {
    this.VillageMembersList();
  }

  goBackToPrevPage() {
    this.location.back();
  }

  AddMainMember() {
    this.router.navigate(['/committee/village-member-list']);
  }

  MemberDetails(user_id: any) {
    this.router.navigate(["/committee/member-details/" + user_id]);
  }

  searchMember(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value.toLowerCase();
    if (!filterValue) {
      this.VillageList = [...this.VillageMemberListData];
      return;
    }
    this.VillageList = this.VillageMemberListData.filter((data: any) => {
      return data.name.toLowerCase().includes(filterValue)
    });
  }

  VillageMembersList() {
    let data = {
      user_id: 0,
      name: "",
      address: "",
      contact_no: "",
      whatsapp_no: "",
      business: "",
      office_contact: "",
      office_address: "",
      village_id: Number(this.village_id),
      current_city_id: 0,
      education: "",
      dob: "",
      blood_group: "",
      image: "", // Assuming 'image' is a property of the member object
      //image_file:"",
      relation_id: 0,
      main_member_id: 0,
      maternal_name: "",
      maternal_village_id: 0,
      is_verified: 0,
      user_type_id: 0,
      password: "",
      created_by: 0,
      Action: 'VILLAGEWISEMAINMEMBER',
    };
    this.mainService.putApi(ApiUrls.verifiedMemberList, data, 1).subscribe((res: any) => {
      if (res.status == 1) {
        this.VillageList = res.user;
        this.VillageMemberListData = res.user;
      }
      else {
        this.toasterService.toastError(res.response);
      }
    });
  }

}
